import { useEffect, useRef, useState } from "react";
import { EyeOff, UserCheck, WifiOff } from "lucide-react";

const Chip = ({ icon: Icon, tone, label, names, testId }) => (
  <span className={`flex items-center gap-2 rounded-full border-2 px-4 py-1.5 text-[min(1.2rem,1.9vh)] font-semibold max-w-[30vw] truncate ${tone}`} title={names.join(", ")} data-testid={testId}>
    <Icon className="h-5 w-5 shrink-0" />{label} ({names.length}): {names.join(", ")}
  </span>
);

const useReturned = (offline) => {
  const prev = useRef(null);
  const [back, setBack] = useState([]);
  const key = offline.join("|");
  useEffect(() => {
    const before = prev.current;
    prev.current = offline;
    if (!before) return undefined;
    const now = new Set(offline);
    const came = before.filter((n) => !now.has(n));
    if (!came.length) return undefined;
    setBack(came);
    const t = setTimeout(() => setBack([]), 3500);
    return () => clearTimeout(t);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return back;
};

export const BoardAlerts = ({ state }) => {
  const offline = state.offline || [];
  const away = state.away || [];
  const back = useReturned(offline);
  return (
    <>
      {away.length > 0 && <Chip icon={EyeOff} tone="border-[#FACC15]/70 bg-[#FACC15]/10 text-[#FDE68A]" label="Uygulamadan çıkan" names={away} testId="board-away" />}
      {offline.length > 0 && <Chip icon={WifiOff} tone="border-red-500/60 bg-red-500/10 text-red-200" label="Bağlantısı kopan" names={offline} testId="board-offline" />}
      {back.length > 0 && (
        <div className="fixed top-[11vh] left-1/2 -translate-x-1/2 z-40 anim-pop flex items-center gap-3 rounded-full border-2 border-[#22C55E] bg-[#0B0F16]/95 px-6 py-3 font-display text-[min(2rem,3vh)] font-bold text-[#4ADE80] shadow-[0_0_30px_rgba(34,197,94,0.4)]" data-testid="board-returned">
          <UserCheck className="h-[3.4vh] w-[3.4vh]" />{back.join(", ")} geri döndü!
        </div>
      )}
    </>
  );
};
